import React from 'react';
import { CloseInfoPanel, InfoPanel, Nav, StyledIconButton } from './styles';
import { PrimaryNavbarProps } from './interface';
import SVGIcon from '../../atoms/SVGIcon';
import ThemeV2 from '../../../componentsV2/theme';

const PrimaryNavbar = (props: PrimaryNavbarProps) => {
  const {
    isLeftAsideOpen,
    isRightAsideOpen,
    toggleLeftAsideOpen,
    renderInfoPanelContent,
    isLeftNavHovered,
    setLeftNavHoveredToTrue,
    setLeftNavHoveredToFalse,
  } = props;

  return (
    <>
      <Nav
        isLeftAsideOpen={isLeftAsideOpen}
        isRightAsideOpen={isRightAsideOpen}
        aria-label="primary navigation menu"
        role="navigation"
        onMouseEnter={(e: React.MouseEvent<HTMLElement, MouseEvent>) => {
          const target = e.target as HTMLButtonElement;
          if (target.id !== 'float-button') {
            setLeftNavHoveredToTrue();
          }
        }}
        onMouseLeave={() => {
          setLeftNavHoveredToFalse();
        }}
        isHovered={isLeftNavHovered}
      >
        <InfoPanel
          isLeftAsideOpen={isLeftAsideOpen}
          isHovered={isLeftNavHovered}
        >
          <CloseInfoPanel onClick={toggleLeftAsideOpen}>
            <SVGIcon icon="round-close" color={ThemeV2.palette.gray6} />
          </CloseInfoPanel>
          {renderInfoPanelContent({
            isHoveredWhenCollapsed: isLeftNavHovered && !isLeftAsideOpen,
          })}
        </InfoPanel>
        <StyledIconButton
          type="button"
          isActive
          onClick={toggleLeftAsideOpen}
          isLeftAsideOpen={isLeftAsideOpen}
          isRightAsideOpen={isRightAsideOpen}
          isHovered={isLeftNavHovered}
          id="float-button"
        >
          {isLeftAsideOpen ? (
            <SVGIcon icon="carat-left" size="20px" />
          ) : (
            <SVGIcon icon="carat-right" size="20px" />
          )}
        </StyledIconButton>
      </Nav>
    </>
  );
};

const MemoizedPrimaryNav = React.memo(PrimaryNavbar);
MemoizedPrimaryNav.displayName = 'PrimaryNavbar';

export default MemoizedPrimaryNav;

/*
import { SecondaryPanel } from '../../../interfaces/Layout';

import Avatar from '../../atoms/Avatar';
import Popover, { TriggerActionType } from '../../molecules/Popover';
import routesList from '../../../aV2/routes/routesList';
import { ADMIN_SETTINGS } from '../../../languages/en/home';
import { getFullName } from '../../../Utils/user';
import {
  SplitNames,
  TreatmentTypes,
} from '../../../hooks/useSplitSdkConfig/constants';
import { useFeatureSplit } from '../../../hooks/useFeatureSplit';

activeNavItem,
toggleNavBar,
onProfileClick,
onProfileOutsideClick,
onProfileAnywhereElseClick,
unreadNotificationsCount,
renderInfoPanelContent,
currentUserId,
currentUserProfile,
isCurrentUserAdmin,
showQuickStepProgress,
quickSetupProgress = 0,
hideQuickSetup = false,

const currentUserFullName = useMemo(
  () => getFullName(currentUserProfile),
  [currentUserProfile],
);

const { treatment: newInformationArchitectureTreatment } = useFeatureSplit(
  SplitNames.NEW_INFORMATION_ARCHITECTURE,
);

const PopoverContent = useMemo(
  () => (
    <PopoverContainer onClick={onProfileAnywhereElseClick}>
      <div>Deleting this soon</div>
    </PopoverContainer>
  ),
  [onProfileAnywhereElseClick],
);

{newInformationArchitectureTreatment !== TreatmentTypes.ON && (
  <PrimaryNav
    isLeftAsideOpen={isLeftAsideOpen}
    hasAdminOption={isCurrentUserAdmin}
    isRightAsideOpen={isRightAsideOpen}
    isHovered={isLeftNavHovered}
  >
    <li>
      <Popover
        popoverPosition="right-start"
        triggerAction={TriggerActionType.click}
        xAxisOffset={4}
        onOutsideClick={onProfileOutsideClick}
        referenceContent={
          <IconButton
            type="button"
            onClick={onProfileClick}
            data-id={SecondaryPanel.PROFILE}
            aria-label={SecondaryPanel.PROFILE}
            isActive={activeNavItem === SecondaryPanel.PROFILE}
            tabIndex={0}
          >
            <Avatar
              img={currentUserProfile.image}
              name={currentUserFullName}
              userId={currentUserId}
              size="32px"
            />
          </IconButton>
        }
        popoverContent={PopoverContent}
        closeOnPopoverClick
      />
    </li>
    <li>
      <IconButton
        type="button"
        onClick={toggleNavBar}
        data-id={SecondaryPanel.ASSEMBLY}
        aria-label={SecondaryPanel.ASSEMBLY}
        isActive={activeNavItem === SecondaryPanel.ASSEMBLY}
        tabIndex={0}
      >
        <SVGIcon icon="home" />
      </IconButton>
    </li>
    <li>
      <IconButton
        type="button"
        onClick={toggleNavBar}
        data-id={SecondaryPanel.NOTIFICATIONS}
        aria-label={SecondaryPanel.NOTIFICATIONS}
        isActive={activeNavItem === SecondaryPanel.NOTIFICATIONS}
        tabIndex={0}
        showUnread={unreadNotificationsCount}
      >
        <SVGIcon icon="notification" />
      </IconButton>
    </li>
    {showQuickStepProgress && isCurrentUserAdmin && !hideQuickSetup && (
      <li>
        <IconButton
          type="button"
          onClick={toggleNavBar}
          data-id={SecondaryPanel.QUICK_SETUP}
          aria-label={SecondaryPanel.QUICK_SETUP}
          isActive={activeNavItem === SecondaryPanel.QUICK_SETUP}
          tabIndex={0}
          showUnread={quickSetupProgress >= 100 ? 0 : 1}
        >
          <SVGIcon icon="quick-setup" />
        </IconButton>
      </li>
    )}
    {isCurrentUserAdmin && (
      <li>
        <Link to={routesList.ADMIN}>
          <IconButton
            type="button"
            data-id={ADMIN_SETTINGS}
            aria-label={ADMIN_SETTINGS}
            tabIndex={0}
          >
            <SVGIcon icon="admin-with-gear" />
          </IconButton>
        </Link>
      </li>
    )}
  </PrimaryNav>
)}
*/
